import { observable } from 'mobx';
import BaseStore from '@src/utils/store/base-store';
import useMount from '@src/utils/hooks/use-mount';
import $$tracker from '@src/tracker';
import { aLink } from '@src/utils/common-util';
import { NEW_SERVER_SPECIAL_LINK } from '@src/constants/urls';

class MainStore extends BaseStore {
  // 游戏对应官网地址
  @observable gameIndexUrl = 'https://jx.xoyo.com/index1/';

  // Kv背景图
  @observable kvImage = require('./images/bg.png');
  // KV背景视频
  @observable kvVideo = 'https://static-jx.xoyo.com/video/20260226/neizongjueqi.mp4';

  // 按钮列表
  @observable
  btnColumnList = [
    {
      name: '内功崛起',
      url: '/container?section=1'
    },
    {
      name: '门派调优',
      url: '/container?section=5'
    },
    {
      name: '界面洞玄',
      url: '/container?section=2'
    },
    {
      name: '开年新服',
      outlink: true,
      url: NEW_SERVER_SPECIAL_LINK
    },
    {
      name: '礼酬侠士',
      url: '/container?section=3'
    },
    {
      name: '玩法焕新',
      url: '/container?section=4'
    }
  ];

  clickCol = item => {
    $$tracker.clickHomepageButton(item.name);
    if (item.outlink) {
      aLink(item.url);
      return;
    }
    this.redirect(item.url, false);
  };

  use() {
    super.use();
    useMount(async () => {
      console.log('componentDidMount');
    });
  }
}

export default MainStore;
